<template>
    <div class="pay-step text-center" style="padding-bottom: 40px;">
<!--        <div class="upload-tips text-info">导入说明：请先下载本项目-->
<!--            <el-button class="upload_link" @click="downloadExcel" type="text">批量确认成果</el-button>-->
<!--                                           文件，在文件中录入成果数据再进行导入.-->
<!--        </div>-->
        <div class="tips">
            <div class="hd">请先下载本项目批量确认成果文件</div>
            <div class="bd">在文件中录入成果数据后再进行导入</div>
            <div class="ft" @click="downloadExcel"><img src="../../assets/img/icon-excel.png" alt="">{{info.name}}-批量确认成果.xlsx<el-button class="upload_link" type="text">下载</el-button></div>
        </div>
        <el-upload
            class="upload-demo__huge"
            :action="actionUrl"
            :headers="headers"
            drag
            name="results_excel"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-remove="removeFile"
            :limit="1"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv">
            <i class="iconfont icon-shangchuanwenjian"></i>
            <div class="el-upload__text">
                点击此处上传录入完成的文件
                <div class="btn-wraper">
                    <el-button type="primary">
                        上传文件
                    </el-button>
                </div>
            </div>
        </el-upload>
    </div>
</template>

<script>
import router from '@/router'

export default {
    name: 'Step1',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            num: 0,
            actionUrl: process.env.VUE_APP_BASE + '/api/user/project/uploadresults',
            userInfo: {},
            projects: [],
            headers: {},
            timer: null,
            info: {}
        }
    },
    mounted () {
        this.getNum(this.$route.query.id)
        this.headers = { token: localStorage.getItem('token') }
        this.getUserInfo()
        this.getProInfo()
    },
    methods: {
        downloadExcel () {
            if (this.num > 1) {
                this.download(`${process.env.VUE_APP_BASE}/api/user/downloadexportresults?id=${this.$route.query.id}&type=all`, '批量确认成果.xlsx')
            } else if (this.num === 1) {
                this.download(`${process.env.VUE_APP_BASE}/api/user/downloadexportresults?id=${this.$route.query.id}`, '批量确认成果.xlsx')
            } else {
                clearTimeout(this.timer)
                this.timer = setTimeout(function () {
                    this.downloadExcel()
                }, 1000)
            }
        },
        download (url, fileName = '') {
            let eleLink = document.createElement('a')
            let authorization = localStorage.getItem('token')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = url + '&authorization=' + authorization
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        uploadSuccess (res) {
            if (res.code === 0) {
                if (this.num > 1) {
                    router.push(`/index/project/check/step4?id=${this.$route.query.id}&path=${res.data.fullpath}`)
                } else {
                    router.push(`/index/project/check/step2?id=${this.$route.query.id}&path=${res.data.fullpath}`)
                }
            } else {
                this.$message.error(res.message)
            }
        },
        getProInfo () {
            this.$http.get('/api/user/project/info', {
                params: {
                    id: this.$route.query.id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        beforeUpload () {
            // console.log(1)
        },
        removeFile (res) {
            this.form.path = ''
        },
        getNum (pid) {
            this.$http.get(`/api/user/project/getdemandnum`, {
                params: {
                    pid
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.num = res.data.demand_num * 1
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        getUserInfo () {
            try {
                if (window.localStorage.getItem('USERINFO')) {
                    this.userInfo = JSON.parse(window.localStorage.getItem('USERINFO'))
                } else {
                    throw new Error('获取本地userInfo失败')
                }
            } catch (err) {
                this.$http.get('/api/userinfo')
                    .then(res => {
                        if (res.code === 0) {
                            this.userInfo = res.data
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";

    .pay-step {
        .upload-tips {
            margin: 0 0 20px;
        }
    }

    .tips {
        .hd {
            font-size: 18px;
            margin-top: 30px;
            font-weight: bold;
        }
        .bd {
            font-size: 16px;
            margin-top: 20px;
            color: #999;
        }
        .ft {
            font-size: 16px;
            cursor: pointer;
            margin: 40px 0;
            img {
                height: 16px;
                margin-right: 5px;
                margin-bottom: 1px;
                vertical-align: middle;
            }
            button {
                margin-left: 15px;
                font-size: 16px;
            }
        }
    }

    .features {
        display: flex;
        width: 740px;
        margin: 35px auto;

        .feature-box {
            flex: 1;
            text-align: center;

            .feature-box__icon {
                .svg-icon {
                    font-size: 36px;
                }
            }

            .feature-box__desc {
                margin-top: 13px;
                line-height: 1.5;
            }
        }
    }
</style>
